export default {
    computed: {
        getTranslations(){

            return Object.keys(this.block.translations);
        }
    },
}